module.exports = __webpack_public_path__ + "static/SquareSerif-Light-webfont-ec6e57f9f97ffbfc7d7c11a8e3aff985.woff2";